import MidiEffect from '../MidiEffect.js';
import ParamMappable from './ParamMappable.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {setEffectParameterValues} from 'actions/index.js';
import {FORWARD, FORWARD_REVERSE, FORWARD_STAY} from 'constants/accumulator-modes.js';

class ControlParametersEffect extends ParamMappable(MidiEffect) {
    constructor(track) {
        super('Control Parameters', track);

        this.setupRampParameters();

        this.counter = -1;

        this.listParameter = new AbstractParameter(
            "list", this,
            () => [],
            {
                defaultValue: [0],
                min: 0,
                max: 1
            });

        this.registerParameter(this.listParameter);
    }

    getText() { return ""; }
    
    set valueList(list) {
        this.listParameter.set([... list]);
    }

    get valueList() {
        return this.listParameter.get();
    }

    stop() {
        super.stop();
        this.counter = -1;
    }

    clear() {
        super.clear();
        this.counter = -1;
    }

    output(time, stepNumber) {
        if (!this.track.sequencerEngine.playing) {
            return this.triggers;
        }
        if (stepNumber === 0 && this.resetAtZero && this.counter !== 0) {
            this.stop();
            this._clear();
        }

        if (this.triggers.length === 0) {
            return this.triggers;
        }

        this.counter++;
        this.setParameterValues(time);
        return this.triggers;
    };

    getParameterValueToSet(i) {
        let value = this.valueList[this.counter % this.valueList.length];
        return this.initialParameterValues[i] + value * (this.getDepth(i) / 100.0);
    }

    getCopy(track, ignoreId=true) {
        let effect = new ControlParametersEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }
}

export default ControlParametersEffect;


